import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Navigate  } from 'react-router-dom';
import TextField from '@mui/material/TextField';

import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import OutlinedInput from '@mui/material/OutlinedInput';
import Serverurl from './Apiurl';

import Person from '@mui/icons-material/Person';
import Lock from '@mui/icons-material/Lock';
import signingBgImg from './images/signingbg.jpg'; 

export default class Businesslogin extends Component {
	
	 constructor(props) {
    super(props);
	 this.state = {Username:'',Password:'',btndisabled:false,pagename:'',errormessage:'',open:false,checked:true,showPassword:false}
	 }
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val}); 
} 
handleChange = (event) => 
{
	this.setState({checked: !this.state.checked});
};
handleClickShowPassword = (event) => 
{
	this.setState({showPassword: !this.state.showPassword});
};

componentDidMount() {
document.body.style.backgroundImage = `url(${signingBgImg})`;
  document.body.style.backgroundSize = 'cover';
  document.body.style.backgroundPosition = 'center';
  document.body.style.backgroundRepeat = 'no-repeat';

	if(localStorage.getItem("GBuserid")!==null)
	{
		this.setState({
							
							
						  }) 
	}else{
		
		this.setState({
							Username: localStorage.getItem("GBUsername"),
							Password: localStorage.getItem("GBpwd"),
						  }) 
		}
		
	

}
componentWillUnmount() {
  // Remove background image from body when leaving this page
  document.body.style.backgroundImage = '';
  document.body.style.backgroundSize = '';
  document.body.style.backgroundPosition = '';
  document.body.style.backgroundRepeat = '';
  document.body.style.backgroundAttachment = '';
}
handleClickLogin= (event) => 
		{
		event.preventDefault();
				
				let Username = this.state.Username;
				let Password = this.state.Password;
				let ischeck = this.state.checked;	
				if(Username==''){
						
				this.setState({errormessage:"Please Enter User Name",open:true});
		 window.scrollTo({        top: 0     })
	return false; 
				}
			
				if(Password==''){
						this.setState({errormessage:"Please Enter Password",open:true});
						 window.scrollTo({        top: 0     })
						 return false; 
					
				}
var formData = new FormData();
				formData.append('action','businesslogin') 	
 
				formData.append('bu_emailid',Username)
				formData.append('bu_password',Password)
				
	
	
axios.post(Serverurl + "ajaxbusiness.php", formData)
.then(res => {

    if (res.data.length > 0) {

        const user = res.data[0];

        if (user.msg == 1) {

    const expiryDate = new Date(user.bu_expirydate);
    const currentDate = new Date();

    if (currentDate > expiryDate) {

        this.setState({
            errormessage: "Your business is expired. Please contact admin.",
            open: true
        });

        window.scrollTo({ top: 0 });

        return;
    }

    localStorage.setItem("GBuserid", user.bu_id);
    localStorage.setItem("GBUsername", Username);
    localStorage.setItem("GBpwd", Password);
    localStorage.setItem("GBname", user.bu_businessname);

    this.setState({
        redirect: true,
        pagename: "/Dashboard"
    });
}
        else if (user.msg == 0) {

            this.setState({
                errormessage: "Email does not exist.",
                open: true
            });

        }
        else if (user.msg == 2) {

            this.setState({
                errormessage: "Incorrect password.",
                open: true
            });

        }
		 else {
       
        this.setState({
          errormessage: "Not a valid login details",
          open: true
        });
        window.scrollTo({ top: 0 });
      }

       
    }
});

}

				
	 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }
	render() {
		if (this.state.redirect) {
    return <Navigate to={this.state.pagename} />;
}
return (
<React.Fragment>
<div className="loginmain"
style={{
    backgroundImage: `url(${signingBgImg})`,
    backgroundSize: 'cover',
  
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    width: '100%'
  }}>
<div className="mainscreen-row">
<div className="main">
	<div className="leftbandlog-col">
		
		
		
	</div>
	<div className="contentseclog-col">
	<div className="contentseclog-collog">
		<div className="logindiv">
		<h2>LogIn</h2>
		<p>Sign In to continue back</p>
			 <p>  <Collapse in={this.state.open}>
							<Alert
							  action={
								<IconButton
								  aria-label="close"
								  color="inherit"
								  size="small"
								  onClick={() => {
								   this.handleErrorclose();
								  }}
								>
								  <CloseIcon fontSize="inherit" />
								</IconButton>
							  } severity="error"
							>
							{this.state.errormessage}
							</Alert>
					</Collapse></p>
					
			<p>
<TextField
  id="txtemailid"
  fullWidth
  variant="outlined"
  name="Username"
  value={this.state.Username}
  inputProps={{tabIndex: "1",maxLength:150}}
  onChange={this.myChangeHandler}
  placeholder="Enter username"
  sx={{
      backgroundColor: "#f0f4f7" ,
	      padding: "6px 0 !important",
		  borderRadius: "5px",
	  "& .MuiOutlinedInput-notchedOutline": {
        border: "none" 
      }
    }}
  InputProps={{
    startAdornment: (
      <InputAdornment position="start">
        <Person />
      </InputAdornment>
    )
  }}
  
  
/>
</p>

			<p>
<FormControl fullWidth >

  <OutlinedInput
    id="txtPassword"
    name="Password"
    fullWidth
    value={this.state.Password}
    inputProps={{tabIndex: "2",maxLength:15}}
    onChange={this.myChangeHandler}
    placeholder="Password"
	sx={{
      backgroundColor: "#f0f4f7",
	  padding: "6px 14px !important",
	  borderRadius: "5px",
	  "& .MuiOutlinedInput-notchedOutline": {
        border: "none" 
      }
	  
    }}
    type={this.state.showPassword ? 'text' : 'password'}

    startAdornment={
      <InputAdornment position="start">
        <Lock />
      </InputAdornment>
    }

    endAdornment={
      <InputAdornment position="end">
        <IconButton
          aria-label="toggle password visibility"
          onClick={this.handleClickShowPassword}
        >
          {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
        </IconButton>
      </InputAdornment>
    }
  />

</FormControl>
</p>

			<p> <FormControlLabel
        label="Remember me"
        control={ <Checkbox  checked={this.state.checked}  onChange={this.handleChange}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
			<div className="loginbtn">
			<Button variant="contained" className="primartybtn" onClick={this.handleClickLogin}
		 style={{ borderRadius: "20px",
    minWidth: "110px", }}>
Sign In
</Button> 


			
		</div>
		<p className="signup" style={{ textAlign: "center", marginTop: "15px" }}>
    Don't have an account?{" "}
    <a 
      href="/Signup" 
      style={{ 
        color: "#0d47a1", 
        textDecoration: "underline", 
        fontWeight: "bold" 
      }}
    >
      SIGN UP
    </a>
  </p>
  
  

  
  
  
  </div>
	</div>
		</div>
	<div className="clear"></div>
</div>
</div>


  <hr style={{ border: "none", borderTop: "1px solid #e0e0e0", margin: "25px 0 15px 0" }} />

	  {/*<p className="need-help" style={{ textAlign: "center",padding: "0px 0px 70px" }}>
  Need help?{" "}
  <a 
    href="/Contactus" 
    style={{ 
      color: "#0d47a1", 
      fontWeight: "bold",
      textDecoration: "underline" 
    }}
  >
    Contact us
  </a>
	  </p>*/}
</div>
</React.Fragment>
)

	}		
}







